// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  restUrl: 'https://dev1.ceres.idrv.app',
  dyspachApiUrl: 'https://api.dyspach.com/v1',
  dyspachApiKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzaGlwcGVySWQiOiJjODY1MDg3My0xZWMyLTQzMjktODVmYi01ZDU5YTY1ZjRjZjgiLCJpYXQiOjE3NDc4MDEyMDEsImV4cCI6MTc3OTM1ODgwMX0.NgBzqlcXivxxvfxj8sMlFhRpJQdyk8VNKYqLwVkfS8w',
  idrv5ApiUrl: 'https://omega-idrv5.up.railway.app/api',
  idrv5ApiKey: ''
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
